"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDisplayConnectionSummaryDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const DISPLAY_CONNECTION_SUMMARY_MAX_RANGE_MS = 90 * 24 * 60 * 60 * 1000;
let DisplayConnectionSummaryRangeConstraint = class DisplayConnectionSummaryRangeConstraint {
    validate(_value, args) {
        const request = args.object;
        const fromMs = Date.parse(request.from);
        const toMs = Date.parse(request.to);
        if (!Number.isFinite(fromMs) || !Number.isFinite(toMs)) {
            return true;
        }
        const rangeMs = toMs - fromMs;
        return rangeMs > 0 && rangeMs <= DISPLAY_CONNECTION_SUMMARY_MAX_RANGE_MS;
    }
    defaultMessage() {
        return "to must be later than from and the range must not exceed 90 days";
    }
};
DisplayConnectionSummaryRangeConstraint = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "isDisplayConnectionSummaryRange", async: false })
], DisplayConnectionSummaryRangeConstraint);
class GetDisplayConnectionSummaryDto {
    displayIds;
    from;
    to;
    bucketSeconds = 3600;
    includeEmptyHighConfidenceBuckets;
}
exports.GetDisplayConnectionSummaryDto = GetDisplayConnectionSummaryDto;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], GetDisplayConnectionSummaryDto.prototype, "displayIds", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], GetDisplayConnectionSummaryDto.prototype, "from", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.Validate)(DisplayConnectionSummaryRangeConstraint),
    __metadata("design:type", String)
], GetDisplayConnectionSummaryDto.prototype, "to", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(900),
    (0, class_validator_1.Max)(86400),
    __metadata("design:type", Number)
], GetDisplayConnectionSummaryDto.prototype, "bucketSeconds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], GetDisplayConnectionSummaryDto.prototype, "includeEmptyHighConfidenceBuckets", void 0);
